const getLatestMasterExecutionIntervals = (store) => {
  return store.latestMasterExecutionIntervals;
};

export { getLatestMasterExecutionIntervals };
